var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{attrs:{"color":"transparent"}},[_c('Toolbar6',{attrs:{"is-fluid":""}}),_c('Contact2Demo'),_c('Footer4Demo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }